import { Disruption } from '@/types/disruptions'
import { Row } from '@tanstack/react-table'
import { compareDesc, parseISO } from 'date-fns'

const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })

export const sortDisruptionsByRoutes = (rowA: Row<Disruption>, rowB: Row<Disruption>): number => {
    const routesA = [...rowA.original.routes.flatMap((item) => item.route)].sort(collator.compare)
    const routesB = [...rowB.original.routes.flatMap((item) => item.route)].sort(collator.compare)

    const maxLength = Math.max(routesA.length, routesB.length)

    for (let i = 0; i < maxLength; i++) {
        const routeA = routesA[i]
        const routeB = routesB[i]

        if (routeA === undefined) return 1
        if (routeB === undefined) return -1

        const cmp = collator.compare(routeA, routeB)
        if (cmp !== 0) return -cmp
    }

    if (rowA.original.start && rowB.original.start) {
        return compareDesc(parseISO(rowA.original.start), parseISO(rowB.original.start))
    }

    return 0
}
